export default "__VITE_ASSET__C78iLUGM__"